import { render, staticRenderFns } from "./insuranceEditor.vue?vue&type=template&id=1079d49f&scoped=true"
import script from "./insuranceEditor.vue?vue&type=script&lang=js"
export * from "./insuranceEditor.vue?vue&type=script&lang=js"
import style0 from "./insuranceEditor.vue?vue&type=style&index=0&id=1079d49f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079d49f",
  null
  
)

export default component.exports